// extracted by mini-css-extract-plugin
export var childrenContainer = "_3n-0";
export var virtualScrollArea = "_3n-1";